import { useState } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "../api/apiClient";   // ✅ GLOBAL CLIENT
import "../css/AddBankDetails.css";
import "../css/mainhome.css";
import { toast } from "react-toastify";
import AppHeader from "../components/AppHeader";

export default function AddBankDetailsScreen() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    holder: "",
    accNo: "",
    ifsc: "",
    bank: "",
    branch: ""
  });

  const walletBalance = localStorage.getItem("walletBalance");

  const onChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSave = async () => {
    const registerId = localStorage.getItem("registerId");
    const payload = {
      registerId,
      accountHolderName: form.holder.trim(),
      accountNumber: form.accNo.trim(),
      bankName: form.bank.trim(),
      branchName: form.branch.trim(),
      ifscCode: form.ifsc.trim().toUpperCase(),
    };

    if (!registerId) {
      toast.error("Session expired. Please login again.");
      navigate("/login-with-mpin", { replace: true });
      return;
    }

    if (
      !payload.accountHolderName ||
      !payload.accountNumber ||
      !payload.bankName ||
      !payload.branchName ||
      !payload.ifscCode
    ) {
      toast.error("Please fill all bank details.");
      return;
    }

    if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(payload.ifscCode)) {
      toast.error("Please enter a valid IFSC code.");
      return;
    }

    try {
      const res = await apiClient.post("/update-bank-details", payload);

      if (res.data.status === true) {
        toast.success("Bank details added successfully.");
        navigate(-1);
      } else {
        toast.error(res.data.msg || "Failed to add bank details.");
      }
    } catch (error) {
      console.error("Error adding bank details:", error?.response || error);
      toast.error("Failed to add bank details.");
    }
  };

  return (
    <div className="mainhome-screen-wrapper">
      <div className="add-bank-page">
        <AppHeader
          title="Add Bank Details"
          walletBalance={walletBalance}
          onBack={() => navigate(-1)}
          onWalletClick={() => navigate("/passbook")}
        />

        <div className="add-bank-body">
          <h2 className="add-bank-title">Bank Details</h2>

          <form
            className="bank-form"
            onSubmit={(e) => {
              e.preventDefault();
              handleSave();
            }}
          >
            <Input
              name="holder"
              placeholder="Account Holder Name"
              value={form.holder}
              onChange={onChange}
            />

            <Input
              name="accNo"
              placeholder="Account Number"
              value={form.accNo}
              onChange={(e) =>
                setForm({ ...form, accNo: e.target.value.replace(/\D/g, "") })
              }
            />

            <Input
              name="bank"
              placeholder="Bank Name"
              value={form.bank}
              onChange={onChange}
            />

            <Input
              name="branch"
              placeholder="Branch Name"
              value={form.branch}
              onChange={onChange}
            />

            <Input
              name="ifsc"
              placeholder="IFSC CODE"
              value={form.ifsc}
              onChange={(e) =>
                setForm({ ...form, ifsc: e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "") })
              }
            />

            <button type="submit" className="save-btn">
              SAVE
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

/* ——— Tiny controlled input component ——— */
function Input({ icon, ...rest }) {
  return (
    <div className="input-wrap">
      {icon && (
        <div className="input-icon">
          <img src={icon} alt="" />
        </div>
      )}
      <input {...rest} />
    </div>
  );
}
